/** @jsxImportSource @emotion/react */
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ModalMultiSelectField, SelectItem } from '../../../shared/ModalMultiSelectField';
import { useAppDispatch } from '../../../core/store';
import {
  fetchDistributionListMembers,
  selectDistributionListMembers,
  selectIsFetching,
} from '../store/assessmentBulkUpdateSlice';
import { AssessmentBulkUpdateFilters } from '../model/assessmentBulkUpdateQueryParams';
import { Contact } from '../../users/model/user.model';

interface DistributionListMemberMultiSelectFieldProps {
  filters: AssessmentBulkUpdateFilters;
  defaultValue?: string[];
  editable?: boolean;
  onUpdate?: (value: string[]) => void;
}

export function DistributionListMemberMultiSelectField({
  filters,
  defaultValue = [],
  editable = false,
  onUpdate,
}: DistributionListMemberMultiSelectFieldProps) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (editable) {
      dispatch(fetchDistributionListMembers(filters));
    }
  }, [dispatch, editable, filters]);
  const { t } = useTranslation();

  const distributionListMemberList = useSelector(selectDistributionListMembers);
  const isFetching = useSelector(selectIsFetching);

  const toSelectItem = (item: Contact | undefined): SelectItem => {
    if (item == null) {
      return { code: '', description: '' };
    }

    return {
      code: item.email,
      description: item.email,
      subdescription: item.name,
    };
  };

  const toString = (item: SelectItem): string => {
    return item.code;
  };

  return (
    <ModalMultiSelectField
      icon='mail'
      defaultValue={
        defaultValue != null
          ? defaultValue.map(v => toSelectItem(distributionListMemberList.find((s: Contact) => s.email === v)))
          : []
      }
      loading={isFetching}
      list={distributionListMemberList.map((b: any): SelectItem => toSelectItem(b) as SelectItem)}
      title={t('assessment.bulkUpdate.filters.distributionList') || ''}
      editable={editable}
      onUpdateValue={(selectedStore: SelectItem[]) => {
        if (onUpdate) {
          onUpdate(selectedStore.map(i => toString(i)));
        }
      }}
    />
  );
}
